import Persist from "@/models/Persist";

class Logon {
  constructor () {
    this.api = {}
    this.attrs = {}
  }

  static validators () {
    return {
      username: [
        v => !!v || 'Field is required'
      ],
      password: [
        v => !!v || 'Field is required'
      ]
    }
  }

  static parserFrom (data) {
    let object = new Logon
    let attrs = {}

    attrs.username = (data.hasOwnProperty('username')) ? data.username : ''
    attrs.password = (data.hasOwnProperty('password')) ? data.password : ''
    attrs.show = false

    object.attrs = attrs
    
    return object
  }
}

export default Logon
